import { requestJson } from "./apiClient";

export async function runVendorDirectoryAdminSource(sourceIdOrKey) {
  return requestJson(
    `/api/admin/data-sources/vendor-directory/${encodeURIComponent(sourceIdOrKey)}/run`,
    { method: "POST" }
  );
}
